import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { AccountInfo } from 'src/app/shared/models/accountInfo.model';
import { LanguageType } from 'src/app/shared/models/enum.model';
import { SetTitle } from 'src/app/shared/ngxs/action/account.action';
import { AccountState } from 'src/app/shared/ngxs/state/account.state';
import { DashboardModel } from './../../shared/models/dashboard.model';
import { GetDashboard } from './../../shared/ngxs/action/dashboard.action';
import { DashboardState } from './../../shared/ngxs/state/dashboard.state';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, OnDestroy {
  model: DashboardModel;
  subscription = new Subscription();

  @Select(DashboardState.statistics)
  statistics$: Observable<DashboardModel>;

  @Select(AccountState.account)
  account$: Observable<AccountInfo>;

  isAdministrator = false;

  constructor(
    private store: Store,
    private translateService: TranslateService
  ) {
    this.model = new DashboardModel();

    this.translateService.get('dashboard').subscribe((x) => {
      this.store.dispatch(new SetTitle(x));
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.store.dispatch(
      new GetDashboard(
        this.translateService.currentLang
      )
    );
    this.subscribeEvents();
  }

  subscribeEvents() {
    this.subscription.add(
      this.translateService.onLangChange.subscribe((x) => {
        if (x) {
          this.store.dispatch(
            new GetDashboard(
              this.translateService.currentLang
            )
          );
        }
      })
    );

    this.subscription.add(
      this.account$.subscribe((x) => {
        if (x) {
          if (x.userType.toString() == 'Administrator') {
            this.isAdministrator = true;
          }
        }
      })
    );

    this.subscription.add(
      this.statistics$.subscribe((x) => {
        if (x) {
          this.model = x;
        }
      })
    );
  }
}
